import { Helmet } from "react-helmet-async";

interface StructuredDataProps {
  data: object;
}

export function StructuredData({ data }: StructuredDataProps) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

// Organization Schema
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "League Life",
  description:
    "Trusted resources and curated experiences for athletes and their families",
  url: "https://leaguelife.com",
  logo: "https://leaguelife.com/android-chrome-512x512.png",
  sameAs: [
    // Add social media URLs when available
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "Customer Support",
    url: "https://leaguelife.com/support",
  },
};

// Mobile Application Schema
export const mobileAppSchema = {
  "@context": "https://schema.org",
  "@type": "MobileApplication",
  name: "League Life",
  operatingSystem: "iOS",
  applicationCategory: "LifestyleApplication",
  description:
    "League Life brings trusted resources and curated experiences to athletes and their families. From vetted local services to wellness and social introductions, we make every move seamless.",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
  },
};

// Service Schema
export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Concierge Service",
  provider: {
    "@type": "Organization",
    name: "League Life",
  },
  description:
    "Curated connections and trusted resources for athletes and their families",
  areaServed: {
    "@type": "Country",
    name: "United States",
  },
};
